import { Input } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { ActiveBasketValueIsAtLeast } from 'entities/campaign/rules';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<ActiveBasketValueIsAtLeast>;

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const onChange = (value: string) =>
    props.update(props.rulesetId, props.ruleIndex, {
      minValue: Number(value),
    });

  return (
    <div data-testid="ActiveBasketValueIsAtLeast">
      <Input
        label="Total value (USD) of the basket is at least"
        ariaLabel="Total value (USD) of the basket is at least"
        inputId="ValueInput"
        type="number"
        onChange={onChange}
        value={props.rule.minValue ?? 0}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
